var _rect, _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgScoreCardPreviewReady(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 256,
    height: 185,
    viewBox: "0 0 256 185",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 256,
    height: 185,
    fill: "#F5F5F5"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_0_1)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 1440,
    height: 928,
    transform: "translate(-408 -325)",
    fill: "white"
  }), /*#__PURE__*/React.createElement("rect", {
    x: -76,
    y: 173,
    width: 91.5374,
    height: 10.8737,
    fill: "url(#paint0_linear_0_1)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1,
    y: 1,
    width: 254,
    height: 183,
    rx: 4,
    fill: "white",
    stroke: "#DADCE0",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M25 1H102V25H25V1Z",
    fill: "#F2F2F2",
    stroke: "#DADCE0",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M102 1H180V25H102V1Z",
    fill: "#F2F2F2",
    stroke: "#DADCE0",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M180 1H251C253.209 1 255 2.79086 255 5V25H180V1Z",
    fill: "#F2F2F2",
    stroke: "#DADCE0",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M25 1L25 184L5 184C2.79086 184 1 182.209 1 180L1.00001 5C1.00001 2.79086 2.79087 0.999999 5.00001 0.999999L25 1Z",
    fill: "#F2F2F2",
    stroke: "#DADCE0",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("line", {
    x1: 35,
    y1: 46,
    x2: 244,
    y2: 46,
    stroke: "#DADCE0",
    strokeWidth: 2,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 35,
    y1: 70,
    x2: 244,
    y2: 70,
    stroke: "#DADCE0",
    strokeWidth: 2,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 35,
    y1: 94,
    x2: 244,
    y2: 94,
    stroke: "#DADCE0",
    strokeWidth: 2,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 35,
    y1: 118,
    x2: 244,
    y2: 118,
    stroke: "#DADCE0",
    strokeWidth: 2,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 35,
    y1: 142,
    x2: 244,
    y2: 142,
    stroke: "#DADCE0",
    strokeWidth: 2,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 35,
    y1: 166,
    x2: 244,
    y2: 166,
    stroke: "#DADCE0",
    strokeWidth: 2,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 102,
    y1: 31,
    x2: 102,
    y2: 177,
    stroke: "#DADCE0",
    strokeWidth: 2,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 180,
    y1: 31,
    x2: 180,
    y2: 177,
    stroke: "#DADCE0",
    strokeWidth: 2,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M38.944 17.172C38.944 17.292 39.052 17.4 39.172 17.4H40.612C40.732 17.4 40.84 17.292 40.84 17.172V10.764H42.556C42.688 10.764 42.784 10.656 42.784 10.536V9.228C42.784 9.108 42.688 9 42.556 9H37.228C37.096 9 37 9.108 37 9.228V10.536C37 10.656 37.096 10.764 37.228 10.764H38.944V17.172Z",
    fill: "#B2B0B9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M45.8222 17.172C45.8222 17.292 45.9182 17.4 46.0502 17.4H47.4782C47.5982 17.4 47.7062 17.292 47.7062 17.172V13.344L50.3942 9.348C50.4902 9.192 50.3942 9 50.2022 9H48.6422C48.5342 9 48.4862 9.06 48.4502 9.108L46.7822 11.568L45.1142 9.108C45.0782 9.06 45.0182 9 44.9222 9H43.3622C43.1702 9 43.0742 9.192 43.1702 9.348L45.8222 13.356V17.172Z",
    fill: "#B2B0B9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M114 17.172C114 17.292 114.096 17.4 114.228 17.4H118.74C118.872 17.4 118.968 17.292 118.968 17.172V15.864C118.968 15.744 118.872 15.636 118.74 15.636H115.884V9.228C115.884 9.108 115.776 9 115.656 9H114.228C114.096 9 114 9.108 114 9.228V17.172Z",
    fill: "#B2B0B9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M121.049 17.172C121.049 17.292 121.145 17.4 121.277 17.4H122.705C122.825 17.4 122.933 17.292 122.933 17.172V13.344L125.621 9.348C125.717 9.192 125.621 9 125.429 9H123.869C123.761 9 123.713 9.06 123.677 9.108L122.009 11.568L120.341 9.108C120.305 9.06 120.245 9 120.149 9H118.589C118.397 9 118.301 9.192 118.397 9.348L121.049 13.356V17.172Z",
    fill: "#B2B0B9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M193.62 12.228C194.508 12.228 195.24 11.508 195.24 10.608C195.24 9.708 194.508 9 193.62 9C192.72 9 192 9.708 192 10.608C192 11.508 192.72 12.228 193.62 12.228ZM192.888 17.196C192.804 17.352 192.912 17.52 193.092 17.52H193.98C194.04 17.52 194.148 17.448 194.184 17.4L198.324 9.444C198.408 9.288 198.3 9.12 198.12 9.12H197.208C197.148 9.12 197.052 9.156 197.004 9.24L192.888 17.196ZM193.62 11.028C193.392 11.028 193.2 10.836 193.2 10.608C193.2 10.392 193.392 10.2 193.62 10.2C193.836 10.2 194.028 10.392 194.028 10.608C194.028 10.836 193.836 11.028 193.62 11.028ZM196.02 16.02C196.02 16.908 196.752 17.64 197.64 17.64C198.54 17.64 199.272 16.908 199.272 16.02C199.272 15.12 198.54 14.4 197.64 14.4C196.752 14.4 196.02 15.12 196.02 16.02ZM197.232 16.02C197.232 15.792 197.424 15.6 197.64 15.6C197.868 15.6 198.06 15.792 198.06 16.02C198.06 16.236 197.868 16.428 197.64 16.428C197.424 16.428 197.232 16.236 197.232 16.02Z",
    fill: "#B2B0B9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M200.366 13.332C200.366 15.732 202.298 17.64 204.698 17.64C205.766 17.64 206.798 17.268 207.614 16.476C207.698 16.392 207.71 16.236 207.626 16.152L206.69 15.156C206.618 15.072 206.462 15.072 206.378 15.144C205.946 15.516 205.43 15.72 204.77 15.72C203.414 15.72 202.406 14.616 202.406 13.284C202.406 11.94 203.402 10.812 204.758 10.812C205.346 10.812 205.886 10.992 206.378 11.424C206.462 11.508 206.594 11.508 206.678 11.424L207.614 10.452C207.71 10.356 207.71 10.212 207.602 10.116C206.786 9.372 205.898 9 204.698 9C202.298 9 200.366 10.932 200.366 13.332Z",
    fill: "#B2B0B9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M209.051 17.292C209.051 17.412 209.159 17.52 209.279 17.52H210.707C210.839 17.52 210.935 17.412 210.935 17.292V14.136H214.367V17.292C214.367 17.412 214.463 17.52 214.595 17.52H216.023C216.143 17.52 216.251 17.412 216.251 17.292V9.348C216.251 9.228 216.143 9.12 216.023 9.12H214.595C214.463 9.12 214.367 9.228 214.367 9.348V12.372H210.935V9.348C210.935 9.228 210.839 9.12 210.707 9.12H209.279C209.159 9.12 209.051 9.228 209.051 9.348V17.292Z",
    fill: "#B2B0B9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M217.725 13.332C217.725 15.732 219.645 17.628 222.033 17.628C223.773 17.628 225.009 16.848 225.009 16.848C225.057 16.812 225.105 16.764 225.105 16.656L225.093 13.428C225.093 13.308 224.997 13.2 224.877 13.2H222.465C222.333 13.2 222.237 13.296 222.237 13.428V14.616C222.237 14.736 222.333 14.832 222.465 14.832H223.221V15.528C222.861 15.672 222.501 15.72 222.153 15.72C220.845 15.72 219.777 14.64 219.777 13.332C219.777 12.012 220.833 10.908 222.141 10.908C222.729 10.908 223.257 11.064 223.713 11.484C223.809 11.556 223.941 11.556 224.037 11.472L224.985 10.464C225.081 10.368 225.069 10.224 224.961 10.14C224.145 9.432 223.041 9.012 222.033 9.012C219.645 9.012 217.725 10.932 217.725 13.332Z",
    fill: "#B2B0B9"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 35,
    y: 53,
    width: 30,
    height: 12,
    rx: 4,
    fill: "#F2F2F2"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 35,
    y: 76,
    width: 52,
    height: 12,
    rx: 4,
    fill: "#F2F2F2"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 35,
    y: 100,
    width: 52,
    height: 12,
    rx: 4,
    fill: "#F2F2F2"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 35,
    y: 124,
    width: 52,
    height: 12,
    rx: 4,
    fill: "#F2F2F2"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 35,
    y: 148,
    width: 61,
    height: 12,
    rx: 4,
    fill: "#F2F2F2"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 35,
    y: 30,
    width: 53,
    height: 12,
    rx: 4,
    fill: "#F2F2F2"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 111,
    y: 53,
    width: 34,
    height: 12,
    rx: 4,
    fill: "#F2F2F2"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 111,
    y: 76,
    width: 59,
    height: 12,
    rx: 4,
    fill: "#F2F2F2"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 111,
    y: 100,
    width: 46,
    height: 12,
    rx: 4,
    fill: "#F2F2F2"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 111,
    y: 124,
    width: 46,
    height: 12,
    rx: 4,
    fill: "#F2F2F2"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 111,
    y: 148,
    width: 46,
    height: 12,
    rx: 4,
    fill: "#F2F2F2"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 111,
    y: 30,
    width: 34,
    height: 12,
    rx: 4,
    fill: "#F2F2F2"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 189,
    y: 53,
    width: 34,
    height: 12,
    rx: 4,
    fill: "#F2F2F2"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 189,
    y: 76,
    width: 34,
    height: 12,
    rx: 4,
    fill: "#F2F2F2"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 189,
    y: 100,
    width: 46,
    height: 12,
    rx: 4,
    fill: "#F2F2F2"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 189,
    y: 124,
    width: 46,
    height: 12,
    rx: 4,
    fill: "#F2F2F2"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 189,
    y: 148,
    width: 46,
    height: 12,
    rx: 4,
    fill: "#F2F2F2"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 189,
    y: 30,
    width: 34,
    height: 12,
    rx: 4,
    fill: "#F2F2F2"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_0_1",
    x1: -76,
    y1: 183.017,
    x2: 1.10921,
    y2: 183.017,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#EFF0F1",
    stopOpacity: 0.1
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#DADCDF"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_0_1"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 1440,
    height: 928,
    fill: "white",
    transform: "translate(-408 -325)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgScoreCardPreviewReady);
export default __webpack_public_path__ + "static/media/ScoreCardPreviewReady.587f9df41f792aaa306a769007e05047.svg";
export { ForwardRef as ReactComponent };